export const STATUS_STYLE = {
  ricevuto: "bg-blue-50 text-blue-700 border-blue-200",
  in_lavorazione: "bg-amber-50 text-amber-700 border-amber-200",
  in_attesa: "bg-violet-50 text-violet-700 border-violet-200",
  risolto: "bg-emerald-50 text-emerald-700 border-emerald-200",
  chiuso: "bg-slate-100 text-slate-600 border-slate-200",
};

export const StatusBadge = ({ status, meta, testId }) => (
  <span data-testid={testId} className={`inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${STATUS_STYLE[status] || STATUS_STYLE.chiuso}`}>{meta?.statuses?.[status] || status}</span>
);

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");
